import React, { useState } from "react";

import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";

import GreyTextField from "Components/GreyTextField";
import AddIcon from '@material-ui/icons/Add';

const MAX_LENGTH = 50;

function CheckboxInputField({customField, setCustomField}) {
	const [value, setValue] = useState("");

	function addOption() {
		if (value.length >= MAX_LENGTH) {
			return;
		}

		if (value.length <= 0) {
			return;
		}

		// get latest id;
		let id = 0;
		if (customField.checkbox_options.length) {
			id = customField.checkbox_options[customField.checkbox_options.length - 1].id + 1;
		}


		if (customField.checkbox_options.length >= 1) { // only allow 1 fiel=
			return;
		}

		setCustomField({
			...customField, 

			checkbox_options: [
				...customField.checkbox_options, 
				{id: id, label: value}
			]
		});

		setValue("");
	}

	function handleEnter(event) {
		if (event.key === 'Enter') {
			addOption();
    }
	}

	return (
			<Card elevation={0} style={{backgroundColor: "#F5F5F5"}}>
				<Grid container item xs={12} alignItems="center">
					<Grid item xs={9} alignItems="center">
						<GreyTextField 
							onKeyDown={handleEnter} 
							fullWidth value={value} 
							placeholder="Add Option..." 
							onChange={(event) => {
								if (event.target.value.length >= MAX_LENGTH) return; 
								setValue(event.target.value);
							}}
						/>
					</Grid>
					<Grid item xs={3} container justify="flex-end">
						<IconButton onClick={addOption} style={{marginRight: '4px'}}>
							<AddIcon />	
						</IconButton>
					</Grid>
				</Grid>
			</Card>
		)
}

export default function CheckboxOptionsEditor({customField, setCustomField}) {
	return (
		<CheckboxInputField customField={customField} setCustomField={setCustomField} />
	)
}